import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-flagged-products-table',
  templateUrl: './flagged-products-table.component.html',
  styleUrls: ['./flagged-products-table.component.css']
})
export class FlaggedProductsTableComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
